import React from 'react';
import { useParams } from 'react-router-dom';
import AxiosDataIsLoaded
  from '@avtechsoftware/react-component-library/src/components/common/AxiosDataWrapper/AxiosDataIsLoaded/AxiosDataIsLoaded';
import AxiosDataWrapper
  from '@avtechsoftware/react-component-library/src/components/common/AxiosDataWrapper/AxiosDataWrapper';
import { useDispatch, useSelector } from 'react-redux';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import {
  clearSingleAlertSlice,
  fetchSingleAlert,
  selectSingleAlertCrudOperation,
  selectSingleAlertCrudStatus,
  selectSingleAlertInitialLoading,
} from '../../../../redux/slices/singleAlertSlice/singleAlertSlice';

import GenericErrorFallback from '../../../common/GenericErrorFallback/GenericErrorFallback';
import { CrudType } from '../../../../utility/types/CrudType';
import { CrudStatus } from '../../../../utility/types/CrudStatus';
import AlertDetailsActivatedView from '../AlertDetailsPageRender/AlertDetailsActivatedView/AlertDetailsActivatedView';
import { selectSessionInformation } from '../../../../redux/slices/sessionSlice';
import { selectDeviceListInitialLoading } from '../../../../redux/slices/deviceList/deviceListSlice';

function AlertDetailsLayout() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { activeSubscription } = useSelector(selectSessionInformation);
  const hasAdvancedAlerting = activeSubscription.activeTierHasAdvancedAlerting === true;

  React.useEffect(() => {
    dispatch(fetchSingleAlert({ alertId: id }));
    return () => {
      dispatch(clearSingleAlertSlice());
    };
  }, []);

  const operation = useSelector(selectSingleAlertCrudOperation);
  const status = useSelector(selectSingleAlertCrudStatus);
  const devicesLoading = useSelector(selectDeviceListInitialLoading);
  const isInitialAlertDataLoading = useSelector(selectSingleAlertInitialLoading);
  const isBeingDeleted = operation === CrudType.DELETE && status === CrudStatus.PENDING;
  if (isInitialAlertDataLoading || isBeingDeleted || devicesLoading
  ) {
    return (
      <div className="row d-flex justify-content-center my-5">
        <div>
          <ProgressSpinner />
        </div>
      </div>
    );
  }

  if (operation === CrudType.DELETE && status === CrudStatus.SUCCESS) {
    window.location.assign('/s/alerts');
  }

  if (operation === CrudType.READ && status === CrudStatus.ERROR) {
    return (
      <div className="row d-flex justify-content-center my-5">
        <div>
          <GenericErrorFallback
            resetErrorBoundary={() => window.location.reload()}
            error="Unexpected error loading alert"
          />
        </div>
      </div>
    );
  }

  return (
    <AxiosDataWrapper url="/subscription/fetch-scrubbed-user-list" config={{ dataTitle: 'users' }}>
      <AxiosDataIsLoaded>
        <AlertDetailsActivatedView
          hasAdvancedAlerting={hasAdvancedAlerting}
        />
      </AxiosDataIsLoaded>
    </AxiosDataWrapper>
  );
}

export default AlertDetailsLayout;
